import { useQueryClient } from "@tanstack/react-query";
import WorkPreferencesForm from "@components/work_preferences/work_preferences_form.tsx";
import { useWorkPreferencesForm } from "@hooks/use_work_preferences_form.ts";
import useTranslation from "@hooks/use_translation.ts";
import ModalFooter from "./modal_footer.tsx";
import type { SectionProps } from "./types.ts";

const WorkPreferencesSection = ({ data, onClose }: SectionProps) => {
  const { t } = useTranslation("user");
  const queryClient = useQueryClient();
  const wp = data.workPreferencesForm;

  const form = useWorkPreferencesForm(
    wp.paths.workPreferencesPath,
    wp.currentEmploymentTypes,
    wp.currentLanguages,
    wp.currentLocation,
    wp.currentRelocation,
    wp.currentWorksites,
    wp.currentSalary,
  );

  const handleSave = async () => {
    const success = await form.submit();
    if (success) {
      await queryClient.invalidateQueries({ queryKey: ["profile"] });
      onClose();
    }
  };

  return (
    <>
      <WorkPreferencesForm
        form={form}
        className="flex flex-col gap-4"
        languagesHelperText={t("workPreferences.languages.helperText")}
        worksiteOptions={wp.worksites}
        employmentTypeOptions={wp.employmentTypes}
        locationHelperText={t("workPreferences.locationHelperText")}
      />
      <ModalFooter
        section="work_preferences"
        onSave={handleSave}
        onCancel={onClose}
        saving={form.loading}
      />
    </>
  );
};

export default WorkPreferencesSection;
